import axios from "axios";
import { authHeader, hasAuth } from "./auth.header";
import { JsonLine } from "../types";

/* -------------------------------------------------------------------------------- *\
|                               findapiserverurl
\* -------------------------------------------------------------------------------- */
export const findapiserverurl = (): string =>
{
	if (process.env.REACT_APP__API_URL) return process.env.REACT_APP__API_URL;

	const origin: string = window.location.origin;
	return origin.replace('3000', '5050');
}
/* -------------------------------------------------------------------------------- *\
|                               getdays
\* -------------------------------------------------------------------------------- */
export const getdays = async () : Promise<string[]> =>
{
	if (!hasAuth())
	{
		return Promise.resolve([]);
	}
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + `/api/getdays`, { headers: authHeader() }))
		.then(response => 
		{
			var datas = response.data as string[];
			return datas;
		});
}
/* -------------------------------------------------------------------------------- *\
|                               getraces
\* -------------------------------------------------------------------------------- */
export const getraces = async (day: string) : Promise<string[]> =>
{
	if (!hasAuth())
	{
		return Promise.resolve([]);
	}
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + `/api/getraces/${day}`, { headers: authHeader() }))
		.then(response => 
		{
			var datas = response.data as string[];
			return datas;
		});
}
/* -------------------------------------------------------------------------------- *\
|                               getrace
\* -------------------------------------------------------------------------------- */
export const getrace = async (race: string) : Promise<string[]> =>
{
	if (!hasAuth())
	{
		return Promise.resolve([]);
	}
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + `/api/getrace/${race}`, { headers: authHeader() }))
		.then(response => 
		{
			var datas = response.data as string[];
			return datas;
		});
}
/* -------------------------------------------------------------------------------- *\
|                               getjson
\* -------------------------------------------------------------------------------- */
export const getjson = async (race: string) : Promise<string[]> =>
{
	if (!hasAuth())
	{
		return Promise.resolve([]);
	}
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + `/api/getrace/${race}`, { headers: authHeader() }))
		.then(response => 
		{
			var datas = response.data as string[];
			return datas;
		});
}
/* -------------------------------------------------------------------------------- *\
|                               getRaceDatas
\* -------------------------------------------------------------------------------- */
export const getRaceDatas = async (race: string) : Promise<JsonLine[]> =>
{
	console.log("getjson")
	if (!hasAuth())
	{
		return Promise.resolve([]);
	}
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + `/api/getjson/${race}`, { headers: authHeader() }))
		.then(response => 
		{
			var datas = response.data as JsonLine[];
			return datas;
		});
}
